import { render } from "./light-button.vue?vue&type=template&id=67792c88"
import script from "./light-button.vue?vue&type=script&lang=js"
export * from "./light-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__